import {
  Autocomplete,
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { AddCircleOutline, PlaylistAddCheck } from "@mui/icons-material";
import useSWR, { mutate } from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import { useState } from "react";
import { COLORS } from "../../../ui/Theme";
import { sendData } from "../../../lib/dashboard/actions";
import { useRoiPersonalWatchContext } from "../../../context/roi/personal-watch/RoiPersonalWatchContext";

const RoiPersonalWatchStocksForm = () => {
  const { selectedWatch } = useRoiPersonalWatchContext();
  const [selectedStock, setSelectedStock] = useState(null);

  const { data: stocks = [], isLoading } = useSWR(
    "/favorite/favorite-roi-instruments",
    fetchData,
    {
      dedupingInterval: 60000,
    }
  );

  const handleAddStock = async () => {
    const res = await sendData(
      {
        group_id: selectedWatch.id,
        instrument_id: selectedStock.id,
      },
      "/favorite/favorite-roi-instruments"
    );
    if (res.status === 200) {
      mutate(`/favorite/favorite-roi-instruments/${selectedWatch.id}`);
      mutate(`/favorite/favorite-roi-groups`);
    }
  };

  return (
    <Box>
      <Autocomplete
        value={selectedStock}
        onChange={(e, newValue) => setSelectedStock(newValue)}
        options={stocks}
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        loading={isLoading}
        noOptionsText="نتیجه‌ای یافت نشد"
        loadingText="در حال بارگذاری..."
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="یک سهم اضافه کنید"
            variant="outlined"
            fullWidth
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  {selectedStock ? (
                    <IconButton
                      onClick={handleAddStock}
                      style={{ padding: 4, color: COLORS.BLUE }}
                    >
                      <AddCircleOutline />
                    </IconButton>
                  ) : (
                    <PlaylistAddCheck />
                  )}
                </InputAdornment>
              ),
            }}
          />
        )}
        sx={{
          width: { xs: "100%", md: "300px" },
        }}
      />
    </Box>
  );
};

export default RoiPersonalWatchStocksForm;
